<template>
  <div>
    <app-detail-header
      :title="'Organizations'"
      :sub-title="''"
    ></app-detail-header>

    <div class="row mr-2">
      <div class="col-md-12 ml-4">
        <section style="margin-top: 10px">
          <h3>Approved Organizations</h3>
          <p
            v-if="currentApprovedOrgs.length === 0"
            class="alert alert-warning"
          >
            No associated orgs found.
          </p>
          <div class="card" v-for="org in currentApprovedOrgs" :key="org.id">
            <div class="card-body">
              <h5 class="card-title">{{ org.name }}</h5>
              <p class="card-text">{{ org.description }}</p>
            </div>
          </div>

          <!-- <div class="mt-2">
            <h3>Pending Organizations</h3>
            <p
              v-if="currentPendingOrgs.length === 0"
              class="alert alert-warning"
            >
              No pending orgs found.
            </p>
            <div class="card" v-for="org in currentPendingOrgs" :key="org.id">
              <div class="card-body">
                <h5 class="card-title">{{ org.name }}</h5>
                <p class="card-text">{{ org.description }}</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="mt-3">
            <button
              class="btn btn-primary"
              @click="submitOrgs"
              :disabled="submitUpdate.submitting"
            >
              Submit
            </button>
            <p v-if="submitUpdate.submitting" class="alert alert-info">
              Submitting...
            </p>
            <p v-if="submitUpdate.success" class="alert alert-success">
              Updated
            </p>
            <p v-if="submitUpdate.error" class="alert alert-danger">
              {{ error }}
            </p>
          </div> -->
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      // The selected org from the dropdown
      selectedOrg: "",
      searchTerm: "",
      availableOrgs: [],
      currentApprovedOrgs: [],
      currentPendingOrgs: [],
      showPanel: false,
      submitUpdate: {
        submitting: false,
        success: false,
        error: null,
      },
    };
  },
  computed: {
    filteredOrgs() {
      // Return a filtered list of orgs based on the search term
      return this.availableOrgs.filter((org) =>
        org.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    ...mapGetters("login", ["loggedInUser"]),
  },
  mounted() {
    this.updateAvailableOrgs();
  },
  methods: {
    // ...mapActions({
    //   statePrtGetOrgs: types.PRT_ACTION_GET_ORGS,
    //   stateLogin_updateUser: types.USG_ACTION_USER_UPDATE,
    // }),
    updateAvailableOrgs() {
      this.$store.dispatch("party/getOrganisations").then((res) => {
        this.availableOrgs = res.map((item, index) => {
          return {
            ...item, // Spread the original item properties
            id: index, // Add the id property with the index value
          };
        });
        this.updateCurrentAssociatedOrgs();
        this.updateCurrentPendingOrgs();
      });
    },
    updateCurrentAssociatedOrgs() {
      let associatedPartyIds = this.loggedInUser.associatedPartyIds;
      if (associatedPartyIds != "") {
        associatedPartyIds = associatedPartyIds.split(",");
      } else {
        associatedPartyIds = [];
      }
      // Filter the available orgs to only those that are associated
      this.currentApprovedOrgs = this.availableOrgs.filter((org) =>
        associatedPartyIds.includes(org.partyId)
      );
    },
    updateCurrentPendingOrgs() {
      let pendingPartyIds = this.loggedInUser.addedPartyIds;
      if(!pendingPartyIds) return;
      if (pendingPartyIds != "") {
        pendingPartyIds = pendingPartyIds.split(",");
      } else {
        pendingPartyIds = [];
      }
      // Filter the available orgs to only those that are pending
      this.currentPendingOrgs = this.availableOrgs.filter((org) =>
        pendingPartyIds.includes(org.partyId)
      );
    },
    // This method is called when the user selects an org from the dropdown
    associateOrg(id) {
      const org = this.availableOrgs.find((i) => i.id === id);
      // Add the org object to the current orgs list
      this.currentPendingOrgs.push(org);
      // Reset the selected org to empty
      this.selectedOrg = "";
    },
    togglePanel() {
      this.showPanel = !this.showPanel;
    },
    isAssociated(id) {
      return (
        this.currentApprovedOrgs.some((org) => org.id === id) ||
        this.currentPendingOrgs.some((org) => org.id === id)
      );
    },
    // This method is called when the user clicks on the remove button of an org card
    removeOrg(id) {
      // Filter out the org object from the current orgs list by id
      this.currentPendingOrgs = this.currentPendingOrgs.filter(
        (i) => i.id !== id
      );
    },
    async submitOrgs() {
      // A method to update the database with the current orgs
      this.submitUpdate.submitting = true; // Set the submitting flag to true
      this.submitUpdate.success = false; // Reset the success flag to false
      this.submitUpdate.error = null; // Reset the error message to null

      let pendingPartyIds = this.currentPendingOrgs.map((cp) => cp.partyId);
      if (pendingPartyIds.length > 0) {
        pendingPartyIds = pendingPartyIds.join(",");
      } else {
        pendingPartyIds = "";
      }
      try {
        const response = await axios.post("/auth/updateuser", {
          username: this.loggedInUser.username,
          addedPartyIds: pendingPartyIds,
        });
        this.submitUpdate.submitting = false; // Set the submitting flag to true
        this.submitUpdate.success = true;
        let updatedUser = this.loggedInUser;
        updatedUser.addedPartyIds = pendingPartyIds;
        this.stateLogin_updateUser(updatedUser);
        this.updateCurrentAssociatedOrgs();
        setTimeout(() => {
          this.submitUpdate.success = false;
        }, 1000);
      } catch (error) {
        console.error(error);
        this.submitUpdate.submitting = false; // Set the submitting flag to true
        this.submitUpdate.success = false; // Reset the success flag to false
        this.submitUpdate.error = "Unknwon Error";
      }
    },
  },
};
</script>
<style scoped>
.scroller {
  height: 400px; /* adjust the height as per your preference */
  overflow-y: scroll; /* add a vertical scrollbar */
}
.alert {
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

/* Change the font-weight and text-transform of the submit button */
.btn-primary {
  font-weight: bold;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/views/party/LibrarianPartyPanel.vue